import React from 'react'

export default function Footer() {
    let d = new Date();
    return (
        <div className="fixed-bottom">
            <p className="m-3 text-muted">&copy; { d.getFullYear() } MDS Digital Media Pvt. Ltd.</p>
        </div>
    )
}
